var React = require('react');

function BookOpen (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M12 6.25278V19.2528M12 6.25278C10.8321 5.47686 9.24649 5 7.5 5C5.75351 5 4.16789 5.47686 3 6.25278V19.2528C4.16789 18.4769 5.75351 18 7.5 18C9.24649 18 10.8321 18.4769 12 19.2528M12 6.25278C13.1679 5.47686 14.7535 5 16.5 5C18.2465 5 19.8321 5.47686 21 6.25278V19.2528C19.8321 18.4769 18.2465 18 16.5 18C14.7535 18 13.1679 18.4769 12 19.2528","stroke":"#718096","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

BookOpen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BookOpen;

BookOpen.default = BookOpen;
